import React from 'react';
import PhoneInputComponent, { PhoneInputProps } from 'react-phone-input-2';
import './PhoneInput.scss';

const PhoneInput: React.FC<PhoneInputProps> = props => {
	return <PhoneInputComponent value={props.value} onChange={props.onChange} />;
};

export default PhoneInput;
